import { render, staticRenderFns } from "./summary-kra.vue?vue&type=template&id=54ebc881&"
import script from "./summary-kra.vue?vue&type=script&lang=js&"
export * from "./summary-kra.vue?vue&type=script&lang=js&"
import style0 from "./summary-kra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports